export class ShopBrandingForm extends HTMLElement {
  constructor() {
    super();
    this.formData = new FormData();
    this.errorElement = this.querySelector('[data-error]');
    this.form = this.querySelector('[data-custom-form]');
    this.submitButton = this.querySelectorAll('[data-offer-submit]');
    this.errorMessageElement = this.querySelector('[data-error-msg]');
    
    this.handleSendApplication = this.handleSendApplication.bind(this);
  }

  connectedCallback() {
    document.querySelector('[data-offer-submit]').addEventListener('click', this.handleSendApplication);
    document.querySelector('[data-file-upload]').addEventListener('change', (event) => this.validateFile(event.target));
  }
  validateFile(input) {
    const maxSize = 52428800; // 50MB in bytes
    const file = input.files[0];
    
    if (file && file.size > maxSize) {
        alert('File is too large. Maximum size is 50MB.');
        input.value = ''; // Reset input
    }
  }

  async handleSendApplication() {
    this.submitButton.forEach(element => {
      element.setAttribute('loading', '');
    });
    this.errorElement.classList.add('hidden');

    this.formData = new FormData(this.form);

    if (this.form.checkValidity()) {
      try {
        const token = await this.executeRecaptcha();
        const result = await this.sendRequest(token);

        if (result.success) {
          window.location.href = '/pages/thank-you'
        } else {
          this.showError(result.message || 'reCAPTCHA verification failed');
        }
      } catch (error) {
        if (error.name === 'AbortError') {
          this.showError('Request timed out. Please try again.');
        } else {
          this.showError(`An error occurred: ${error.message}`);
          console.error('reCAPTCHA error:', error);
        }
      }
    } else {
      this.showError('Please fill out all required fields correctly.');
      this.form.reportValidity();
    }
    this.submitButton.forEach(element => {
      element.removeAttribute('loading');
    });
  }

  showError(message) {
    this.errorElement.style.display = 'block';
    this.errorMessageElement.innerHTML = message;
  }

  async executeRecaptcha() {
    return await new Promise((resolve, reject) => {
      window.grecaptcha.ready(() => {
        window.grecaptcha
          .execute('6LcmsJEqAAAAAPQ3D_RwkpwEIwL1dZ97u_gxx3VQ', { action: 'submit' })
          .then(resolve)
          .catch(reject);
      });
    });
  }

  async sendRequest(token) {
    const controller = new AbortController();
    const timeoutId = setTimeout(() => { controller.abort(); }, 30000); // 30 seconds timeout

    try {
      this.formData.append('g-recaptcha-response', token);
      const res = await fetch('https://cf-mail-sigg.tim-maier.workers.dev/mailSigg', {
        method: 'post',
        body: this.formData,
        headers: {
          'X-Auth-Token': 'dakjdb398hkw3br93z98zn'
        },
        signal: controller.signal
      });
      clearTimeout(timeoutId);

      if (res.ok) {
        const data = await res.json();
        return { success: data.captchaSuccess, message: data.message };
      } else {
        return { success: false, message: 'Server error' };
      }
    } catch (error) {
      clearTimeout(timeoutId);
      throw error; // Re-throw to be caught in the calling function
    } finally {
      this.formData = new FormData();
    }
  }
}

customElements.define('shop-branding-form', ShopBrandingForm);